import Utils, {
  changeProp,
  changeProps,
  deleteProp,
  deleteProps,
  isSortableBox,
  isContainedView,
  isSortableContainer,
  isBox,
} from "../common/utils";
import { migrateLegacyGuides } from "../common/migrate_legacy_guides.es6";
import { migrateLegacySoundLists } from "../common/migrate_legacy_sound_lists.es6";
import {
  ADD_BOX,
  ADD_NAV_ITEM,
  ADD_RICH_MARK,
  EDIT_RICH_MARK,
  MOVE_BOX,
  CHANGE_START_ANIMATION,
  CHANGE_MIDDLE_ANIMATION,
  CHANGE_END_ANIMATION,
  CHANGE_FINAL_ANIMATION,
  CHANGE_ANIMATION_POSITION_NUMBER,
  CHANGE_SHOW_ANIMATION,
  CHANGE_ANIMATION_DURATIONS,
  UPDATE_BOX,
  UPDATE_BOX_TIMELINE,
  REPAIR_MEDIA_TIMELINES,
  UPDATE_VIDEO_INTERACTIONS,
  UPDATE_BOX_EXIT_ANIMATION,
  DELETE_BOX_EXIT_ANIMATION,
  DELETE_BOX,
  REORDER_SORTABLE_CONTAINER,
  DROP_BOX,
  RESIZE_SORTABLE_CONTAINER,
  DELETE_SORTABLE_CONTAINER,
  CHANGE_COLS,
  CHANGE_ROWS,
  CHANGE_SORTABLE_PROPS,
  REORDER_BOXES,
  DELETE_NAV_ITEM,
  DELETE_CONTAINED_VIEW,
  IMPORT_STATE,
  PASTE_BOX,
  UPDATE_PLUGIN_TOOLBAR,
  TOGGLE_TEXT_EDITOR,
  RESIZE_BOX,
  ROTATE_BOX,
  DUPLICATE_NAV_ITEM,
  DUPLICATE_NAV_ITEM_BY_PAYLOAD,
  IMPORT_EDI,
  UPDATE_TEXT_ANIMATION,
  UPDATE_BOX_ANIMATION,
  DELETE_TEXT_ANIMATION,
  DELETE_BOX_ANIMATION,
  SYNC_SCENE_SUCCESS,
  MIGRATE_LEGACY_GUIDES,
  MIGRATE_LEGACY_SOUND_LISTS,
  PASTE_SCENE,
  APPLY_AIDEA_SMART_ELEMENTS,
  UNGROUP_AIDEA_SMART_ELEMENT,
} from "../common/actions";
import { ID_PREFIX_BOX, ID_PREFIX_SORTABLE_BOX } from "../common/constants";
import { resolveBoxTiming } from "../common/resolveBoxTiming.es6";
import { RotateLeftSharp } from "@mui/icons-material";

function boxCreator(state, action) {
  let position, startanimation, middleanimation, endanimation, finalanimation;
  let level = 0;
  if (
    state[action.payload.ids.parent] &&
    !isContainedView(action.payload.ids.container) &&
    isBox(action.payload.ids.parent)
  ) {
    level = state[action.payload.ids.parent].level + 1;
  }

  if (isSortableBox(action.payload.ids.id)) {
    position = { x: 0, y: 0, type: "relative" };
    level = -1;
  } else {
    position = {
      x: 0,
      y: 0,
      type: "absolute",
    };
  }
  if (isSortableContainer(action.payload.ids.container)) {
    position = {
      x: 0,
      y: 0,
      type: "relative",
    };
  }

  let col = 0;
  let row = 0;
  let timeline = undefined;
  if (action.payload.initialParams) {
    console.log("[boxCreator] initialParams alındı", {
      hasTimeline: !!action.payload.initialParams.timeline,
      timeline: action.payload.initialParams.timeline,
      initialParams: action.payload.initialParams,
    });

    if (action.payload.initialParams.position) {
      position = action.payload.initialParams.position;
    }
    if (action.payload.initialParams.col) {
      col = action.payload.initialParams.col;
    }
    if (action.payload.initialParams.row) {
      row = action.payload.initialParams.row;
    }
    if (action.payload.initialParams.width) {
      // width = action.payload.initialParams.width;
    }
    if (action.payload.initialParams.timeline) {
      timeline = action.payload.initialParams.timeline;
      console.log("[boxCreator] timeline özelliği ayarlandı", { timeline });
    }
  }
  // sortableContainers for boxes inside this box (this is not EditorBoxSortable)
  let children = [];
  let sortableContainers = {};
  if (action.payload.state) {
    let pluginContainers = action.payload.state.__pluginContainerIds;
    if (pluginContainers) {
      for (let key in pluginContainers) {
        children.push(pluginContainers[key].id);
        sortableContainers[pluginContainers[key].id] = sortableContainerCreator(
          key,
          [],
          pluginContainers[key].height,
          action.payload.ids.id
        );
      }
    }
  }

  const newBox = {
    id: action.payload.ids.id,
    parent: action.payload.ids.parent,
    container: action.payload.ids.container,
    level: level,
    col: col,
    row: row,
    position: position,
    startanimation: startanimation,
    middleanimation: middleanimation,
    endanimation: endanimation,
    finalanimation: finalanimation,
    // width: width,
    // height: height,
    content: {}, // action.payload.content,
    draggable: action.payload.draggable,
    resizable: action.payload.resizable,
    showTextEditor: false,
    fragment: {},
    children: children,
    sortableContainers,
    containedViews: [],
    textAnimation: null,
    boxAnimation: null,
    ...(timeline && { timeline }),
  };

  console.log("[boxCreator] Box oluşturuldu", {
    boxId: newBox.id,
    hasTimeline: !!newBox.timeline,
    timeline: newBox.timeline,
    newBox,
  });

  return newBox;
}

function sortableContainerCreator(key = "", children = [], height = "auto", parent) {
  return {
    children: children,
    style: {
      padding: "0px",
      borderColor: "#ffffff",
      borderWidth: "0px",
      borderStyle: "solid",
      opacity: "1",
      textAlign: isBox(parent) ? "left" : "center",
      className: "",
    },
    height: height,
    key: key,
    colDistribution: [100],
    cols: [[100]],
  };
}

function boxReducer(state = {}, action = {}) {
  switch (action.type) {
    case ADD_BOX:
    case PASTE_BOX:
      let a = changeProps(
        state,
        ["children", "sortableContainers"],
        [
          state.children.indexOf(action.payload.ids.container) !== -1 // if parent box contains container indicated
            ? state.children // nothing changes
            : [...state.children, action.payload.ids.container], // adds container to children
          sortableContainersReducer(state.sortableContainers, action),
        ]
      );
      return a;
    case ADD_RICH_MARK:
      return changeProp(state, "containedViews", [
        ...state.containedViews,
        action.payload.mark.connection,
      ]);
    case CHANGE_COLS:
      if (action.payload.parent === state.id) {
        return changeProp(
          state,
          "sortableContainers",
          sortableContainersReducer(state.sortableContainers, action)
        );
      }
      return changeProps(
        state,
        ["col", "row"],
        [
          state.col >= action.payload.distribution.length
            ? action.payload.distribution.length - 1
            : state.col,
          state.col >= action.payload.distribution.length ? 0 : state.row,
        ]
      );
    case CHANGE_SORTABLE_PROPS:
      return changeProp(
        state,
        "sortableContainers",
        sortableContainersReducer(state.sortableContainers, action)
      );
    case CHANGE_ROWS:
      if (action.payload.parent === state.id) {
        return changeProp(
          state,
          "sortableContainers",
          sortableContainersReducer(state.sortableContainers, action)
        );
      }
      return changeProp(
        state,
        "row",
        state.row >= action.payload.distribution.length
          ? action.payload.distribution.length - 1
          : state.row
      );
    case DELETE_BOX:
      return changeProp(
        state,
        "sortableContainers",
        sortableContainersReducer(state.sortableContainers, action)
      );
    case DELETE_SORTABLE_CONTAINER:
      return changeProps(
        state,
        ["children", "sortableContainers"],
        [
          state.children.filter((id) => id !== action.payload.id),
          sortableContainersReducer(state.sortableContainers, action),
        ]
      );
    case DROP_BOX: {
      if (state.id === action.payload.parent || state.id === action.payload.oldParent) {
        // If we are dealing with the new or the previous parents, we need to modify the sortable containers of each one of them to add/delete the dropped box to/from its children
        // Two boxes can have containers with the same name (like plugins inside plugins) so we need to let them know in which box we are. That's why we create a new value in the action.payload
        return changeProp(
          state,
          "sortableContainers",
          sortableContainersReducer(
            state.sortableContainers,
            Object.assign({}, action, {
              payload: Object.assign({}, action.payload, { currentBoxReducer: state.id }),
            })
          )
        );
      } else if (
        state.id === action.payload.id ||
        (action.payload.oldId !== undefined && state.id === action.payload.oldId)
      ) {
        // If we are dealing with the dropped box, we need to modify some of its properties
        let newLevel = isBox(action.payload.parent) ? 1 : 0;
        let isResizable = !(isBox(action.payload.parent) || isSortableBox(action.payload.parent)); // Change from slide to sortable or viceversa
        return changeProps(
          state,
          ["parent", "container", "row", "col", "position", "level", "resizable"],
          [
            action.payload.parent,
            action.payload.container,
            action.payload.row,
            action.payload.col,
            action.payload.position || state.position,
            newLevel,
            isResizable,
          ]
        );
      }
      return state;
    }

    case RESIZE_BOX:
      return changeProp(state, "position", {
        x: action.payload.structure.x || state.position.x,
        y: action.payload.structure.y || state.position.y,
        type: state.position.type,
      });

    case MOVE_BOX:
      return changeProp(state, "position", {
        x: action.payload.x,
        y: action.payload.y,
        type: action.payload.position,
      });

    case ROTATE_BOX:
      return changeProp(state, "transform", action.payload.rotatedegree + "deg");

    case REORDER_SORTABLE_CONTAINER:
      return changeProp(state, "children", action.payload.ids);
    case REORDER_BOXES:
      return changeProp(
        state,
        "sortableContainers",
        sortableContainersReducer(state.sortableContainers, action)
      );
    case RESIZE_SORTABLE_CONTAINER:
      return changeProp(
        state,
        "sortableContainers",
        sortableContainersReducer(state.sortableContainers, action)
      );
    case UPDATE_PLUGIN_TOOLBAR:
      let newSortableContainers = {};
      let newChildren = [];
      if (
        action.payload.name instanceof Array &&
        action.payload.name.indexOf("__pluginContainerIds") > -1
      ) {
        for (let containerKey in action.payload.value[1]) {
          let container = action.payload.value[1][containerKey];
          // if not found -> create new one; otherwise copy existing
          if (!state.sortableContainers[container.id] && action.payload.value[1][containerKey]) {
            newSortableContainers[container.id] = sortableContainerCreator(
              containerKey,
              [],
              container.height,
              action.payload.id
            );
          } else {
            newSortableContainers[container.id] = Utils.deepClone(
              state.sortableContainers[container.id]
            );
          }
          newChildren.push(containerKey);
        }

        // return state;
        return changeProps(
          state,
          [
            /* "content",*/
            "children",
            "sortableContainers",
          ],
          [
            /* action.payload.content,*/
            newChildren,
            newSortableContainers,
          ]
        );
      }
      return state;

    case UPDATE_BOX:
      // sortableContainers for boxes inside this box (this is not EditorBoxSortable) (***** only working with PLUGIN inside PLUGIN)
      let sortableContainers = {};
      let children = [];
      if (action.payload.state.__pluginContainerIds) {
        for (let containerKey in action.payload.state.__pluginContainerIds) {
          let container = action.payload.state.__pluginContainerIds[containerKey];
          // if not found -> create new one; otherwise copy existing
          if (!state.sortableContainers[container.id]) {
            sortableContainers[container.id] = sortableContainerCreator(
              containerKey,
              [],
              container.height,
              action.payload.id
            );
          } else {
            sortableContainers[container.id] = Utils.deepClone(
              state.sortableContainers[container.id]
            );
          }
          children.push(container.id);
        }
      }

      return changeProps(state, ["children", "sortableContainers"], [children, sortableContainers]);
    case DUPLICATE_NAV_ITEM:
      let id = action.payload.boxes[state.id];
      let parent = action.payload.boxes[state.parent]
        ? action.payload.boxes[state.parent]
        : state.parent;
      if (parent === action.payload.id) {
        parent = action.payload.newId;
      }
      let sortableContainersObj = {};
      if (state.sortableContainers) {
        sortableContainersObj = JSON.parse(JSON.stringify(state.sortableContainers));
        for (let sc in sortableContainersObj) {
          let children_boxes = sortableContainersObj[sc].children.map((child) => {
            return action.payload.boxes[child];
          });
          sortableContainersObj[sc].children = children_boxes;
        }
      }
      return { ...state, id, parent, sortableContainers: sortableContainersObj };
    default:
      return state;
  }
}

function singleSortableContainerReducer(state = {}, action = {}) {
  // A dangling container ref can leave `children` undefined; treat as empty so
  // delete/move don't crash on `children.filter`.
  const children = Array.isArray(state.children) ? state.children : [];
  switch (action.type) {
    case ADD_BOX:
    case PASTE_BOX:
      if (
        action.payload.index ||
        (action.payload.initialParams && action.payload.initialParams.index)
      ) {
        let newOrder = [...children];
        newOrder.splice(
          action.payload.index || action.payload.initialParams.index,
          0,
          action.payload.ids.id
        );
        return changeProp(state, "children", newOrder);
      }
      return changeProp(state, "children", [...children, action.payload.ids.id]);
    case CHANGE_COLS:
      let cols = state.cols;
      let distributionLength = action.payload.distribution.length;
      if (distributionLength < cols.length) {
        cols = cols.slice(0, distributionLength);
      }
      let reduced = action.payload.distribution.reduce(function (prev, curr) {
        return prev + curr;
      });
      if (reduced > 99 || reduced <= 101) {
        if (distributionLength > cols.length) {
          let difference = distributionLength - cols.length;
          for (let i = 0; i < difference; i++) {
            cols.push([100]);
          }
        }
      }

      return changeProps(state, ["colDistribution", "cols"], [action.payload.distribution, cols]);
    case CHANGE_ROWS:
      let newCols = state.cols.slice();
      newCols[action.payload.column] = action.payload.distribution;
      return changeProp(state, "cols", newCols);
    case CHANGE_SORTABLE_PROPS:
      return changeProp(
        state,
        "style",
        changeProp(state.style, action.payload.prop, action.payload.value)
      );
    case DELETE_BOX:
      return changeProp(
        state,
        "children",
        children.filter((id) => id !== action.payload.id)
      );
    case DROP_BOX:
      if (
        action.payload.oldContainer === action.payload.container &&
        action.payload.oldParent === action.payload.parent &&
        action.payload.index !== undefined &&
        action.payload.index !== null
      ) {
        let newCh = children.filter((id) => id !== action.payload.id);
        newCh.splice(action.payload.index, 0, action.payload.id);
        return changeProp(state, "children", newCh);
      }
      if (
        state.key === action.payload.oldContainer &&
        action.payload.currentBoxReducer === action.payload.oldParent &&
        action.payload.oldId !== undefined
      ) {
        let newCh = children.filter((id) => id !== action.payload.id);
        newCh.splice(action.payload.index, 0, action.payload.oldId);
        return changeProp(state, "children", newCh);
      } else if (
        state.key === action.payload.oldContainer &&
        action.payload.currentBoxReducer === action.payload.oldParent
      ) {
        let newCh = children.filter((id) => id !== action.payload.id);
        return changeProp(state, "children", newCh);
      } else if (
        state.key === action.payload.container &&
        action.payload.currentBoxReducer === action.payload.parent
      ) {
        if (action.payload.index !== undefined && action.payload.index !== null) {
          let newOrder = [...children];
          newOrder.splice(action.payload.index, 0, action.payload.id);
          return changeProp(state, "children", newOrder);
        }
        return changeProp(state, "children", [...children, action.payload.id]);
      }
      return state;
    case REORDER_BOXES:
      return changeProp(state, "children", action.payload.order);
    case RESIZE_SORTABLE_CONTAINER:
      return changeProp(state, "height", action.payload.height);
    default:
      return state;
  }
}

function sortableContainersReducer(state = {}, action = {}) {
  switch (action.type) {
    case ADD_BOX:
    case PASTE_BOX:
      let a = changeProp(
        state,
        action.payload.ids.container,
        state[action.payload.ids.container]
          ? singleSortableContainerReducer(state[action.payload.ids.container], action)
          : sortableContainerCreator(
              action.payload.ids.container,
              [action.payload.ids.id],
              "auto",
              action.payload.ids.parent
            )
      );
      return a;
    case ADD_NAV_ITEM:
    case ADD_RICH_MARK:
      return state;
    case CHANGE_COLS:
      return changeProp(
        state,
        action.payload.id,
        singleSortableContainerReducer(state[action.payload.id], action)
      );
    case CHANGE_ROWS:
      return changeProp(
        state,
        action.payload.id,
        singleSortableContainerReducer(state[action.payload.id], action)
      );
    case CHANGE_SORTABLE_PROPS:
      return changeProp(
        state,
        action.payload.id,
        singleSortableContainerReducer(state[action.payload.id], action)
      );
    case DELETE_BOX:
      return changeProp(
        state,
        action.payload.container,
        singleSortableContainerReducer(state[action.payload.container], action)
      );
    case DROP_BOX:
      if (action.payload.parent === action.payload.oldParent) {
        // Sibling containers
        if (action.payload.oldContainer !== action.payload.container) {
          // But not the same one
          return changeProps(
            state,
            [action.payload.oldContainer, action.payload.container],
            [
              singleSortableContainerReducer(
                state[action.payload.oldContainer],
                Object.assign({}, action, {
                  payload: Object.assign({}, action.payload, {
                    oldId: state[action.payload.container]?.children?.[0],
                  }),
                })
              ),
              singleSortableContainerReducer(
                state[action.payload.container],
                Object.assign({}, action, {
                  payload: Object.assign({}, action.payload, {
                    oldId: state[action.payload.container]?.children?.[0],
                  }),
                })
              ),
            ]
          );
        }
        return changeProp(
          state,
          action.payload.oldContainer,
          singleSortableContainerReducer(state[action.payload.oldContainer], action)
        );

        // return state; // If we are moving to the same container we do nothing
      } else if (action.payload.currentBoxReducer === action.payload.oldParent) {
        return changeProp(
          state,
          action.payload.oldContainer,
          singleSortableContainerReducer(state[action.payload.oldContainer], action)
        );
      } else if (action.payload.currentBoxReducer === action.payload.parent) {
        return changeProp(
          state,
          action.payload.container,
          singleSortableContainerReducer(state[action.payload.container], action)
        );
      }
      return state;
    case DELETE_SORTABLE_CONTAINER:
      return deleteProp(state, action.payload.id);
    case REORDER_BOXES:
      return changeProp(
        state,
        action.payload.container,
        singleSortableContainerReducer(state[action.payload.container], action)
      );
    case RESIZE_SORTABLE_CONTAINER:
      return changeProp(
        state,
        action.payload.id,
        singleSortableContainerReducer(state[action.payload.id], action)
      );
    default:
      return state;
  }
}

// Frame rate resolveBoxTiming() is driven at across the app (buildLayers,
// VisorCanvasSli, buildElementGraph all use 30). Declared locally so this
// reducer keeps its existing import surface.
const SMART_ELEMENTS_FPS = 30;

/**
 * The timeline slot an Aidea Smart Elements layer must be born into: the slot
 * its source image occupied. Used ONLY by APPLY_AIDEA_SMART_ELEMENTS.
 *
 * Without it a layer is created with `timeline: {}`, resolveBoxTiming reports
 * `endFrame: undefined`, and buildLayers.js:479-483 stretches the clip to
 * `Math.max(startFrame + 150, sceneMaxEndFrame)` — which is why decomposing a
 * 0–7.2s image produced six layers covering the whole 44s scene.
 *
 * Returns a fresh seed object rather than a copy of the source's timeline,
 * because most of that object must NOT come along:
 *   - `visible`    — the source is hidden immediately after this call.
 *   - `trackId`    — would stack every layer onto the source's shared row.
 *   - `splitGroup` — the layers are not split siblings of anything.
 *   - `trimStart/trimEnd/playStartFrame` — media-clip fields, meaningless here.
 * `userSetEndFrame` is likewise left unset: it means "the user dragged the right
 * handle", and resolveBoxTiming honours a bare `endFrame` regardless (all three
 * of its endFrame branches return `timeline.endFrame`).
 *
 * Legacy `animationsById` opacity keyframes live in a sibling slice this reducer
 * cannot read, so `[]` is passed — the same call shape buildElementGraph.js:225
 * uses. A source old enough to encode its slot only in keyframes keeps the old
 * full-scene behaviour instead of getting a wrong slot.
 */
function resolveInheritedLayerTimeline(sourceBox) {
  if (!sourceBox) return {};
  const { startFrame, endFrame } = resolveBoxTiming(sourceBox, [], SMART_ELEMENTS_FPS);
  const hasStart = typeof startFrame === "number" && Number.isFinite(startFrame);
  const hasEnd = typeof endFrame === "number" && Number.isFinite(endFrame);
  // Source had no slot of its own → inherit nothing, behave exactly as before.
  if (!hasStart && !hasEnd) return {};
  return {
    // Written explicitly even when it is 0. VisorCanvasSli nests its endFrame
    // check INSIDE `typeof resolvedStartFrame === "number"`, so an endFrame-only
    // box is cut correctly in the editor timeline but plays to the end of the
    // scene during playback and in the exported video.
    startFrame: hasStart ? startFrame : 0,
    ...(hasEnd ? { endFrame } : {}),
  };
}

export default function (state = {}, action = {}) {
  let newState;
  let temp;
  switch (action.type) {
    case ADD_BOX:
      // if box is contained in sortableContainer, add it as well to its children
      if (isSortableContainer(action.payload.ids.container)) {
        let r = changeProps(
          state,
          [action.payload.ids.id, action.payload.ids.parent],
          [boxCreator(state, action), boxReducer(state[action.payload.ids.parent], action)]
        );
        return r;
      }

      let a = changeProp(state, action.payload.ids.id, boxCreator(state, action));

      return a;
    case REORDER_SORTABLE_CONTAINER:
      return {
        ...state,
        [action.payload.parent]: {
          ...state[action.payload.parent],
          children: [].concat(action.payload.ids),
        },
      };
    case ADD_NAV_ITEM:
      if (action.payload.type === "document") {
        return {
          ...state,
          [action.payload.sortable_id]: {
            parent: action.payload.id,
            id: action.payload.sortable_id,
            container: 0,
            level: -1,
            col: 0,
            row: 0,
            position: { type: "relative", x: 0, y: 0 },
            draggable: false,
            resizable: false,
            showTextEditor: false,
            fragment: {},
            children: [],
            sortableContainers: {},
            containedViews: [],
          },
        };
      }
      return state;
    case PASTE_BOX:
      let ids = Object.keys(action.payload.children);
      let bx = ids.map((k) => {
        return action.payload.children[k].box;
      });
      if (isSortableContainer(action.payload.ids.container)) {
        return changeProps(
          state,
          [action.payload.ids.id, action.payload.ids.parent, ...ids],
          [action.payload.box, boxReducer(state[action.payload.ids.parent], action), ...bx]
        );
      }
      return changeProps(state, [action.payload.ids.id, ...ids], [action.payload.box, ...bx]);
    case MOVE_BOX:
      return changeProp(state, action.payload.id, boxReducer(state[action.payload.id], action));
    case ROTATE_BOX:
      return changeProp(state, action.payload.id, boxReducer(state[action.payload.id], action));
    case RESIZE_BOX:
      return changeProp(state, action.payload.id, boxReducer(state[action.payload.id], action));
    case RESIZE_SORTABLE_CONTAINER:
      return changeProp(
        state,
        action.payload.parent,
        boxReducer(state[action.payload.parent], action)
      );
    case UPDATE_BOX_TIMELINE:
      if (!state[action.payload.id]) return state;
      return {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          timeline: {
            ...(state[action.payload.id].timeline || {}),
            ...action.payload.timeline,
          },
        },
      };
    case REPAIR_MEDIA_TIMELINES: {
      // Batched UPDATE_BOX_TIMELINE: legacy media boxes get the timeline window
      // the editor/visor were only deriving on the fly, in one undoable step.
      const patches = action.payload.patches || {};
      const ids = Object.keys(patches).filter((id) => state[id]);
      if (ids.length === 0) return state;
      const next = { ...state };
      for (const id of ids) {
        next[id] = {
          ...state[id],
          timeline: { ...(state[id].timeline || {}), ...patches[id] },
        };
      }
      return next;
    }
    case UPDATE_VIDEO_INTERACTIONS: {
      // Array CRUD on box.timeline.interactions for the Interactive Video
      // MVP. No-op if the box is missing so the reducer is safe against
      // stale references (e.g. action queued before a parallel DELETE_BOX).
      const { id, op } = action.payload;
      if (!state[id]) return state;
      const box = state[id];
      const timeline = box.timeline || {};
      const current = Array.isArray(timeline.interactions) ? timeline.interactions : [];
      let nextInteractions = current;
      if (op === "add" && action.payload.interaction) {
        nextInteractions = current.concat(action.payload.interaction);
      } else if (op === "update" && action.payload.interactionId) {
        const patch = action.payload.patch || {};
        nextInteractions = current.map((it) =>
          it && it.id === action.payload.interactionId ? { ...it, ...patch } : it
        );
      } else if (op === "remove" && action.payload.interactionId) {
        nextInteractions = current.filter((it) => it && it.id !== action.payload.interactionId);
      } else if (op === "replace" && Array.isArray(action.payload.interactions)) {
        nextInteractions = action.payload.interactions;
      } else {
        // Unknown op or missing payload — leave state untouched.
        return state;
      }
      if (nextInteractions === current) return state;
      return {
        ...state,
        [id]: {
          ...box,
          timeline: { ...timeline, interactions: nextInteractions },
        },
      };
    }
    case UPDATE_BOX:
    case TOGGLE_TEXT_EDITOR:
    case UPDATE_PLUGIN_TOOLBAR:
      let updatedState = JSON.parse(JSON.stringify(state));
      for (let b in action.payload.deletedBoxes) {
        delete updatedState[action.payload.deletedBoxes[b]];
      }
      return changeProp(
        updatedState,
        action.payload.id,
        boxReducer(updatedState[action.payload.id], action)
      );
    case ADD_RICH_MARK:
    case EDIT_RICH_MARK:
      // If rich mark is connected to a contained view (new or existing), mark.connection will include this information;
      // otherwise, it's just the id/url and we're not interested
      if (
        action.payload.mark.id &&
        action.payload.view &&
        isContainedView(action.payload.view.id) &&
        (action.payload.mark.connectMode === "new" ||
          action.payload.mark.connectMode === "existing")
      ) {
        let newBoxState = {
          ...state,
          [action.payload.mark.origin]: {
            ...state[action.payload.mark.origin],
            containedViews: state[action.payload.mark.origin].containedViews.concat([
              action.payload.view.id,
            ]),
          },
        };
        if (action.payload.mark.connectMode === "new" && action.payload.view.type === "document") {
          newBoxState = {
            ...newBoxState,
            [action.payload.view.boxes[0]]: {
              parent: action.payload.view.id,
              id: action.payload.view.boxes[0],
              container: 0,
              level: -1,
              col: 0,
              row: 0,
              position: { type: "relative", x: 0, y: 0 },
              draggable: false,
              resizable: false,
              showTextEditor: false,
              fragment: {},
              children: [],
              sortableContainers: {},
              containedViews: [],
            },
          };
        }
        return newBoxState;
      }
      return state;
    case REORDER_BOXES:
      return changeProp(
        state,
        action.payload.parent,
        boxReducer(state[action.payload.parent], action)
      );
    case CHANGE_SORTABLE_PROPS:
      return changeProp(
        state,
        action.payload.parent,
        boxReducer(state[action.payload.parent], action)
      );
    case DROP_BOX:
      if (isSortableBox(action.payload.parent) || isBox(action.payload.parent)) {
        // New parent is box
        if (action.payload.oldParent === action.payload.parent) {
          // Sae parent as before but container or row changes
          // We need to change the box's container and tell the parent
          let oldId = Object.keys(state).find(
            (key) => state[key].container === action.payload.container
          );
          let container = action.payload.container;
          let oldContainer = action.payload.oldContainer;

          return changeProps(
            state,
            [action.payload.id, oldId, action.payload.parent],
            [
              boxReducer(state[action.payload.id], action),
              boxReducer(
                state[oldId],
                Object.assign({}, action, {
                  payload: Object.assign({}, action.payload, {
                    container: oldContainer,
                    oldContainer: container,
                    oldId: oldId,
                  }),
                })
              ),
              boxReducer(state[action.payload.parent], action),
            ]
          );
        } // Different parent
        if (isBox(action.payload.oldParent) || isSortableBox(action.payload.oldParent)) {
          // Old parent was a box
          // We need to change the new and old parent
          return changeProps(
            state,
            [action.payload.id, action.payload.parent, action.payload.oldParent],
            [
              boxReducer(state[action.payload.id], action),
              boxReducer(state[action.payload.parent], action),
              boxReducer(state[action.payload.oldParent], action),
            ]
          );
        } // Old parent was a page or something else
        // We just need to change the new parent
        return changeProps(
          state,
          [action.payload.id, action.payload.parent],
          [
            boxReducer(state[action.payload.id], action),
            boxReducer(state[action.payload.parent], action),
          ]
        );
      } // New parent is something other than a box
      if (!isBox(action.payload.parent) && !isSortableBox(action.payload.parent)) {
        // Old parent was a box
        // We need to change the box's parent and container and remove the child from the old parent.
        return changeProps(
          state,
          [action.payload.id, action.payload.oldParent],
          [
            boxReducer(state[action.payload.id], action),
            boxReducer(state[action.payload.oldParent], action),
          ]
        );
      } // Old parent was a page or something else
      // We do nothing because boxes cannot change their parents to another page.
      return state;
    // return changeProp(state, action.payload.id, boxReducer(state[action.payload.id], action));
    case CHANGE_COLS:
      newState = changeProp(
        state,
        action.payload.parent,
        boxReducer(state[action.payload.parent], action)
      );
      action.payload.boxesAffected.forEach((id) => {
        newState = changeProp(newState, id, boxReducer(newState[id], action));
      });
      return newState;
    case CHANGE_ROWS:
      newState = changeProp(
        state,
        action.payload.parent,
        boxReducer(state[action.payload.parent], action)
      );
      action.payload.boxesAffected.forEach((id) => {
        newState = changeProp(newState, id, boxReducer(newState[id], action));
      });
      return newState;
    case DELETE_BOX:
      let children = action.payload.children ? action.payload.children : [];
      let which_children = children.concat(action.payload.id);
      temp = deleteProps(state, children.concat(action.payload.id));

      // If box is in sortableContainer, delete from its children aswell
      if (isSortableContainer(action.payload.container)) {
        return changeProp(
          temp,
          action.payload.parent,
          boxReducer(state[action.payload.parent], action)
        );
      }
      return temp;
    case DELETE_CONTAINED_VIEW:
      let newBoxes = JSON.parse(JSON.stringify(state));
      Object.keys(action.payload.parent).forEach((el) => {
        if (newBoxes[el] && newBoxes[el].containedViews) {
          let index = newBoxes[el].containedViews.indexOf(action.payload.ids[0]);
          if (index > -1) {
            newBoxes[el].containedViews.splice(index, 1);
          }
        }
      });
      return deleteProps(newBoxes, action.payload.boxes);
    case DELETE_SORTABLE_CONTAINER:
      let tempState = deleteProps(state, action.payload.children);
      return changeProp(
        tempState,
        action.payload.parent,
        boxReducer(state[action.payload.parent], action)
      );
    case DELETE_NAV_ITEM:
      // TODO: Delete linked marks
      return deleteProps(state, action.payload.boxes);
    case IMPORT_STATE:
      return action.payload.present.boxesById || state;
    case SYNC_SCENE_SUCCESS: {
      if (!action.payload.boxesById) return state;
      let merged = { ...state };
      Object.keys(action.payload.boxesById).forEach((id) => {
        if (merged[id]) {
          merged[id] = { ...merged[id], ...action.payload.boxesById[id] };
        }
      });
      return merged;
    }
    case IMPORT_EDI:
      return { ...state, ...action.payload.state.boxesById };
    case DUPLICATE_NAV_ITEM:
      let newBoxesArr = {};
      for (let box in action.payload.boxes) {
        let newId = action.payload.boxes[box];
        newBoxesArr[newId] = boxReducer(state[box], action);
      }
      return { ...state, ...newBoxesArr };
    case DUPLICATE_NAV_ITEM_BY_PAYLOAD:
      let newBoxesArr2 = {};
      action.payload.boxes.forEach((box) => {
        newBoxesArr2[box.id] = box;
      });

      return { ...state, ...newBoxesArr2 };
    case PASTE_SCENE:
      return { ...state, ...action.payload.boxes };
    case UPDATE_TEXT_ANIMATION:
      return changeProp(
        state,
        action.payload.id,
        changeProp(state[action.payload.id], "textAnimation", {
          animation: action.payload.animation,
          duration: action.payload.duration,
          delay: action.payload.delay,
        })
      );
    case UPDATE_BOX_ANIMATION:
      const updatedBox = changeProp(state[action.payload.id], "boxAnimation", {
        animation: action.payload.animation,
        duration: action.payload.duration,
        delay: action.payload.delay,
      });
      return changeProp(state, action.payload.id, updatedBox);
    case DELETE_TEXT_ANIMATION:
      const { textAnimation, ...boxWithoutTextAnimation } = state[action.payload.id];
      return {
        ...state,
        [action.payload.id]: boxWithoutTextAnimation,
      };
    case DELETE_BOX_ANIMATION:
      const { boxAnimation, ...boxWithoutBoxAnimation } = state[action.payload.id];
      return {
        ...state,
        [action.payload.id]: boxWithoutBoxAnimation,
      };
    case UPDATE_BOX_EXIT_ANIMATION: {
      const updatedExitBox = changeProp(state[action.payload.id], "boxExitAnimation", {
        animation: action.payload.animation,
        duration: action.payload.duration,
      });
      return changeProp(state, action.payload.id, updatedExitBox);
    }
    case DELETE_BOX_EXIT_ANIMATION: {
      const { boxExitAnimation, ...boxWithoutExit } = state[action.payload.id];
      return { ...state, [action.payload.id]: boxWithoutExit };
    }
    case MIGRATE_LEGACY_GUIDES: {
      const out = migrateLegacyGuides({
        boxesById: state,
        pluginToolbarsById: action.payload.pluginToolbarsById || {},
        navItemsById: action.payload.navItemsById || {},
        containedViewsById: action.payload.containedViewsById || {},
      });
      return out.boxesById;
    }
    case MIGRATE_LEGACY_SOUND_LISTS:
      return migrateLegacySoundLists({ ...action.payload, boxesById: state }).boxesById;
    case APPLY_AIDEA_SMART_ELEMENTS: {
      const ls = action.payload;
      if (!ls || !Array.isArray(ls.layers)) return state;
      const next = { ...state };
      // The layers REPLACE the source image, so they inherit the timeline slot
      // it occupied. Resolved here, before the source is hidden below.
      const inheritedTimeline = resolveInheritedLayerTimeline(next[ls.sourceBoxId]);
      // Hide source box via the existing timeline.visible convention so the
      // user can recover it via the timeline UI.
      if (next[ls.sourceBoxId]) {
        next[ls.sourceBoxId] = {
          ...next[ls.sourceBoxId],
          timeline: {
            ...(next[ls.sourceBoxId].timeline || {}),
            visible: false,
          },
        };
      }
      // Insert a new box per emitted layer at the position pre-computed by middleware.
      // Tag every member with a shared groupId so the UI can recognise them as a logical
      // group, and seed a default fade-in boxAnimation so "play scene" animates them
      // together out of the box. Per-element timing is still editable via the timeline.
      const groupId = ls.jobId ? `grp-${ls.jobId}` : null;
      // "Fade" matches BOX_ANIMATION_PRESETS in
      // _visor/components/canvas/VisorBox.jsx and
      // _editor/components/canvas/editor_shortcuts/BoxAnimationModal.jsx.
      // "fadeIn" / "Fade In" do NOT match — the visor's preset lookup would
      // return undefined and no animation would play.
      const defaultBoxAnimation = { animation: "Fade", delay: 0, duration: 0.4 };
      for (const layer of ls.layers) {
        next[layer.id] = {
          id: layer.id,
          parent: ls.navId,
          container: 0,
          level: 0,
          col: 0,
          row: 0,
          position: layer.position,
          draggable: true,
          resizable: true,
          showTextEditor: false,
          content: {},
          fragment: {},
          children: [],
          sortableContainers: {},
          containedViews: [],
          timeline: { ...inheritedTimeline },
          ...(groupId ? { groupId } : {}),
          boxAnimation: { ...defaultBoxAnimation },
        };
      }
      return next;
    }
    case UNGROUP_AIDEA_SMART_ELEMENT: {
      const id = action.payload?.boxId;
      if (!id || !state[id] || !state[id].groupId) return state;
      const { groupId: _drop, ...rest } = state[id];
      return { ...state, [id]: rest };
    }
    default:
      return state;
  }
}
